import React from "react";
import { ShortL } from "../../_metronic/_partials";

export function ShortListPage(props) {
  return <ShortL {...props}/>;
}